import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/show_inspect/agro_exporter/${customer_id}/${agro_exporter_id}`
    );
  },
  fetchContainer({customer_id, agro_exporter_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/show_inspect/container/${customer_id}/${agro_exporter_id}/${container_id}`
    );
  },
  fetchTemplate({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/show_inspect/quality_template/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}`
    );
  },
  fetchInspect({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id, quality_inspect_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/show_inspect/quality_inspect/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}/${quality_inspect_id}`
    );
  },
  fetchGroups({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/show_inspect/list_quality_groups/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}`
    );
  },
  destroy({ container_id, quality_inspect_id }) {
    return RequesterV1.delete(
      `customer/quality_control/destination/show_inspect/${container_id}/${quality_inspect_id}/destroy`
    );
  },
};
